import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { Component, inject, OnInit, signal, model } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Tanque } from 'src/app/models/tanque.model';
import { SettlementsService } from 'src/app/services/settlements.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { IconsService } from 'src/app/shared/services/icons.service';
import { v4 as uuidv4 } from 'uuid';
import { PlanFile } from 'src/app/models/plan-file.model';
import { catchError, concatMap, EMPTY, finalize, from, of, switchMap, tap, toArray } from 'rxjs';

@Component({
  selector: 'app-tanque-edit',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Combustible</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block tank-menu">        
        <ul app-nav-tanques [currentView]="currentView" class="list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto tanque-container">
        @if (loading()) {
            <div class="loading">
              <fa-icon [icon]="icons.faSpinner" [animation]="'spin'"></fa-icon>
            </div>
        }
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">Tanques</h2>
            <p class="text-muted" style="font-size: 14px;">Configura los tanques asignados a los edificios.</p>
          </div>
        </div>
        <div class="d-flex">
          <div class="flex-fill ms-auto">
              <div class="list-group rounded-4 rounded-md-5">
              <div class="list-group-item p-4">
                <app-form-tanque
                  [tanque]="tanque"
                  [permissions]="permissions"
                  (updateForm)="editTanque($event)"
                  (cancelForm)="cancelEdit()"
                  (onLoading)="updateLoading($event)"
                  (deleteVideoEvent)="this.ngOnInit()"
                  [(planFiles)]="files"
                  (newEmptyFile)="newFile()"
                  [isEdition]="true"
                ></app-form-tanque>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./tanque-edit.component.scss']
})
export class TanqueEditComponent implements OnInit {
  files = model<PlanFile[] | null>(null);
  tanque: Tanque | null = null;
  loading = signal<boolean>(false);
  video = model<string>();
  profile: any;
  permissions: any;
  currentView: string = 'tanques';

  payload: any = {
    page: 1,
    per_page: 100,
  };
  storageService = inject(StorageService);
  icons = inject(IconsService);
  constructor(
    private router: Router,
    private activateRoute: ActivatedRoute,
    private store: SettlementsService,
    private toastr: ToastrService,
    private breadcrumbService: BreadcrumbService,
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.payload.id = this.profile ? this.profile.id : 0;
    console.log('this.profile ===> ', this.profile);
  }

  ngOnInit(): void {
    this.activateRoute.params.subscribe(params => {
      this.store.getTanque(params['id'], true).subscribe({
        next: (tanque: any) => {
          if (tanque?.id) {
            this.tanque = {...tanque};
          }
        },
        error: (err: any) => {
          this.toastr.error('Error', 'Ocurrió un error al obtener el tanque');
        },
      });
    });
    this.breadcrumbService.set('@tanques', 'Tanques');
    this.breadcrumbService.set('@editarTanque', this.tanque?.name || 'Tanque');
  }

  newFile() {
    const emptyFile: PlanFile = {
      uiId: uuidv4()
    } as PlanFile;
    this.files.update((prev) => prev ? ([...prev, emptyFile]) : [emptyFile]);
  }

  editTanque(data: any) {
    this.loading.set(true);
    this.store.updateTanque(data.id, data).pipe(
      tap(() => {
        this.toastr.success('Exito', 'Tanque actualizado correctamente.');
        this.router.navigate(['/combustibles/tanques']);
      }),
      catchError((err) => {
        this.toastr.error('Error', 'Ocurrió un error al actualizar el tanque');
        return of(err);
      }),
      switchMap(() => {
        const files = this.files()?.filter(f => !f.id && !f.file_url && f.file);
        if (files?.length === 0) return EMPTY;
        return from(files!).pipe(
          concatMap(f => {
            const formData = this.plansFormData(f);
            return this.store.saveTankPlans(`${this.tanque?.id}`, formData).pipe(
              catchError((err) => {
                console.warn(err);
                return EMPTY;
              })
            )
          }),
          toArray()
        )
      }),
      finalize(() => {
        this.loading.set(false);
      })
    )
    .subscribe({
      next: () => {
        this.toastr.success(
          'Planos agregados',
          `Los planos han sido agregados al tanque`
        );
      }
    });
  }

  cancelEdit() {
    console.log("CANCEL")
    this.router.navigate(['/tanques']);
  }

  updateLoading(value: boolean) {
    this.loading.set(value);
  }

  plansFormData(plan: PlanFile): FormData {
    const file = plan.file!;
    const formData = new FormData();
    formData.append('blueprint[name]', file.name);
    formData.append('blueprint[file]', file);
    return formData;
  }

}
